export default defineNuxtPlugin(() => {
  const route = useRoute()
  const { origin } = useRequestURL()

  useHead({
    link: [
      {
        rel: 'canonical',
        href: computed(() => origin + route.path),
      },
    ],
  })
})
